import { useQuery } from '@tanstack/react-query';
import { healthSchema } from '@competa/shared';
import { useTranslation } from 'react-i18next';
import { apiGet, ApiRequestError } from '../../api/client';
import { Button } from '../../components/Button';
import styles from './HealthStatus.module.css';

/**
 * Fragt den Gesundheitstest der API ab und validiert die Antwort.
 * @returns Die validierte Antwort von `GET /api/health`.
 */
function fetchHealth() {
  return apiGet('/health', healthSchema);
}

/**
 * Zeigt den Systemstatus (Server und Datenbank) anhand von `GET /api/health`.
 * Dient in M1 als erste echte Ende-zu-Ende-Verbindung zwischen Oberfläche und API.
 */
export function HealthStatus() {
  const { t } = useTranslation();
  const query = useQuery({
    queryKey: ['health'],
    queryFn: fetchHealth,
    retry: false,
  });

  if (query.isPending) {
    return <p role="status">{t('common.loading')}</p>;
  }

  if (query.isError) {
    const error = query.error;
    const key =
      error instanceof ApiRequestError && error.code === 'db_unavailable'
        ? 'health.db_unavailable'
        : 'health.error';
    return (
      <div role="alert" className={`${styles.box} ${styles.error}`}>
        <p>{t(key)}</p>
        <Button variant="secondary" onClick={() => void query.refetch()}>
          {t('common.retry')}
        </Button>
      </div>
    );
  }

  return (
    <p role="status" className={`${styles.box} ${styles.ok}`}>
      {t('health.ok')}
    </p>
  );
}
